import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import config from "config/config";
import { SVGComponentProps } from "untitledui-js-base";

export const MenuRow = ({
  text,
  isDisabled = false,
  HugeIcon,
  Icon,
  badge
}: {
  text: string;
  isDisabled?: boolean;
  HugeIcon?: IconSvgElement;
  Icon?: React.FC<SVGComponentProps>;
  // A count beside the label. Absent or zero shows nothing rather than a "0",
  // which reads as a state the row is in rather than a tally.
  badge?: number;
}) => {
  if (config.environment !== "production" && HugeIcon && Icon)
    throw new Error("Don't pass Icon and HugeIcon. Pick one");

  return (
    <span className="flex gap-2 items-center">
      {HugeIcon ? (
        <HugeiconsIcon
          size={20}
          icon={HugeIcon}
          className={isDisabled ? "text-content-100" : "text-content-200"}
        />
      ) : null}
      {Icon ? (
        <Icon
          size="20"
          className={isDisabled ? "stroke-content-100" : "stroke-content-200"}
        />
      ) : null}

      <p className={isDisabled ? "text-content-100" : "text-content-1000"}>
        {text}
      </p>

      {badge ? (
        <span className="ml-auto rounded-full bg-alpha-80 px-1.5 text-xs text-content-500">
          {badge}
        </span>
      ) : null}
    </span>
  );
};
